import $ from 'jquery';

export default class TemplateAddresses {
  constructor(section) {
    this.$el = $(section.el);

    this._bindEvents();
    this.prepareAddresses();
  }

  _bindEvents() {
    $('.delete-address', this.$el).on('click', () => this.deleteAddress());
    $('.edit-address', this.$el).on('click', () => this.editAddress());
    $('.cancel-edit', this.$el).on('click', () => this.on());
    $('.toggle-new-address', this.$el).on('click', () => this.toggleNewAddress());
    $('.select-wrapper select', this.$el).on('click', () => this.updateSelectedText());
  }

  prepareAddresses() {
    new Shopify.CountryProvinceSelector('address-country', 'address-province', {
      hideElement: 'address-province-container',
    });

    const addresses = $('.customer-address', this.$el);
    if (addresses.length) {
      addresses.each((index, address) => {
        const addressID = $(address).data('address-id');
        new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
          hideElement: `address-province-container-${addressID}`,
        });
      });
    }

    const selectableOptions = $('.select-wrapper select', this.$el);

    selectableOptions.map(select => this.updateSelectedText(null, select));
  }

  updateSelectedText(event, selectedText) {
    const select = event ? $(event.target) : $(selectedText);
    const selectedValue = select.find('option:selected').text();

    if (selectedValue !== '') {
      select.prev('.selected-text').text(selectedValue);
    }

    if (select.attr('name') === 'address[country]') {
      let addressID = $(select).attr('id').split('address-country-')[1];
      addressID = addressID ? `#address-province-${addressID}` : '.new-address-province';

      this.updateSelectedText(null, $(addressID));
    }
  }

  deleteAddress(event) {
    if (event) { event.preventDefault(); }

    const addressID = $(event.target).parents('[data-address-id]').data('address-id');
    Shopify.CustomerAddress.destroy(addressID);
  }

  editAddress(event) {
    if (event) { event.preventDefault(); }

    const addressID = $(event.currentTarget).parents('[data-address-id]').data('address-id');
    $(`.customer-address[data-address-id='${addressID}']`).addClass('editing');
    $(`.customer-address-edit-form[data-address-id='${addressID}']`).addClass('show');
  }

  cancelEditing(event) {
    if (event) { event.preventDefault(); }

    const addressID = $(event.target).parents('[data-address-id]').data('address-id');
    $(`.customer-address[data-address-id='${addressID}']`).removeClass('editing');
    $(`.customer-address-edit-form[data-address-id='${addressID}']`).removeClass('show');
  }

  toggleNewAddress(event) {
    if (event) { event.preventDefault(); }

    $('.add-new-address').toggle();
    $('.customer-new-address').toggleClass('show');
  }
}
